import React from 'react';
const STATS = [{
  value: '6',
  label: 'Tomos clínicos'
}, {
  value: '+300',
  label: 'Protocolos listos'
}, {
  value: '10',
  label: 'Algoritmos de decisión'
}, {
  value: '+30',
  label: 'Casos resueltos'
}];
export function Stats() {
  return <section aria-label="El sistema en números" className="w-full bg-navy-900 py-7 sm:py-9" data-id="element-204" data-mp="2ixpdiwpjpb2y">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-205" data-mp="2nv7bjs20y5w6">
        <div className="grid grid-cols-2 gap-y-6 sm:grid-cols-4" data-id="element-206" data-mp="297mby84cyot0">
          {STATS.map(stat => <div key={stat.label} className="flex flex-col items-center border-cream-200/15 px-2 text-center sm:border-r sm:last:border-r-0" data-id="element-207" data-mp="2dz4akpiwsdat">
              <span className="font-display text-3xl font-bold leading-none text-gold-400 sm:text-4xl" data-id="element-208" data-mp="256apuckp0lpk">
                {stat.value}
              </span>
              <span className="mt-1.5 text-[11px] font-bold uppercase tracking-[0.1em] text-cream-100/80 sm:text-xs" data-id="element-209" data-mp="1qa1uvn7u4uiy">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}